import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './Biblioteca.css';

const Biblioteca = () => {
  const [recorridos, setRecorridos] = useState([]);
  const [recorridosFiltrados, setRecorridosFiltrados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [codigoCompartir, setCodigoCompartir] = useState({});
  const [busqueda, setBusqueda] = useState('');

  useEffect(() => {
    cargarRecorridos();
  }, []);

  useEffect(() => {
    filtrarRecorridos();
  }, [busqueda, recorridos]);

  const cargarRecorridos = async () => {
    try {
      const response = await api.get('/recorridos');
      if (response.data.success) {
        setRecorridos(response.data.recorridos);
      }
    } catch (err) {
      console.error('Error al cargar recorridos:', err);
    } finally {
      setLoading(false);
    }
  };

  const generarCompartir = async (id) => {
    try {
      const response = await api.post(`/recorridos/${id}/compartir`);
      if (response.data.success) {
        setCodigoCompartir({
          ...codigoCompartir,
          [id]: response.data.url_compartir
        });
      }
    } catch (err) {
      alert('Error al generar código de compartir');
    }
  };

  const filtrarRecorridos = () => {
    let filtrados = [...recorridos];

    if (busqueda) {
      filtrados = filtrados.filter(recorrido =>
        recorrido.titulo.toLowerCase().includes(busqueda.toLowerCase()) ||
        (recorrido.descripcion && recorrido.descripcion.toLowerCase().includes(busqueda.toLowerCase()))
      );
    }

    setRecorridosFiltrados(filtrados);
  };

  const copiarEnlace = (url) => {
    navigator.clipboard.writeText(url);
    alert('Enlace copiado al portapapeles');
  };

  if (loading) {
    return <div className="loading">Cargando biblioteca...</div>;
  }

  return (
    <div className="main-content">
      <div className="container">
        <div className="biblioteca-header">
          <div>
            <h1>Mi Biblioteca</h1>
            <p className="biblioteca-subtitle">Todos tus recorridos virtuales en un solo lugar</p>
          </div>
        </div>

        {recorridos.length > 0 && (
          <div className="biblioteca-search">
            <input
              type="text"
              placeholder="Buscar en biblioteca..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              className="search-input"
            />
            <span className="search-results">
              {recorridosFiltrados.length} de {recorridos.length} recorridos
            </span>
          </div>
        )}
        
        {recorridos.length === 0 ? (
          <div className="empty-state">
            <p>No tienes recorridos en tu biblioteca</p>
            <Link to="/crear-recorrido" className="btn btn-primary">
              Crear Recorrido
            </Link>
          </div>
        ) : recorridosFiltrados.length === 0 ? (
          <div className="empty-state">
            <h2>No se encontraron recorridos</h2>
            <p>Intenta ajustar tu búsqueda</p>
          </div>
        ) : (
          <div className="biblioteca-grid">
            {recorridosFiltrados.map((recorrido) => (
              <div key={recorrido.id} className="biblioteca-item">
                <div className="biblioteca-header">
                  <h3>{recorrido.titulo}</h3>
                  <span className={`badge ${recorrido.publico ? 'badge-publico' : 'badge-privado'}`}>
                    {recorrido.publico ? 'Público' : 'Privado'}
                  </span>
                </div>
                
                <p className="biblioteca-descripcion">
                  {recorrido.descripcion || 'Sin descripción'}
                </p>
                
                <div className="biblioteca-info">
                  <span>📸 {recorrido.total_imagenes || 0} imágenes</span>
                  <span>📅 {new Date(recorrido.fecha_creacion).toLocaleDateString()}</span>
                </div>
                
                <div className="biblioteca-actions">
                  <Link 
                    to={`/visor/id/${recorrido.id}`}
                    className="btn btn-primary btn-sm"
                  >
                    Ver Recorrido
                  </Link>
                  <button
                    onClick={() => generarCompartir(recorrido.id)}
                    className="btn btn-success btn-sm"
                  >
                    Compartir
                  </button>
                </div>
                
                {codigoCompartir[recorrido.id] && (
                  <div className="compartir-box">
                    <input
                      type="text"
                      value={codigoCompartir[recorrido.id]}
                      readOnly
                      className="compartir-input"
                    />
                    <button
                      onClick={() => copiarEnlace(codigoCompartir[recorrido.id])}
                      className="btn btn-sm"
                    >
                      Copiar
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Biblioteca;

